import { UnitOfMeasure } from '@bechtel/types';

//TODO: Remove when local values for language are sent from the server
export interface Lang {
  id: number;
  name: string;
  locale: string;
  languageValue: string;
}

export interface Quantity {
  id: number;
  name: string;
  unit: string;
  enumValue: UnitOfMeasure;
}

export const languageList: Lang[] = [
  { id: 1, name: 'English (U.S.)', locale: 'en', languageValue: 'english' },
  { id: 2, name: 'Spanish', locale: 'es', languageValue: 'spanish' },
];

export const unitOfMeasureList: Quantity[] = [
  { id: 1, name: 'Hours (hrs)', unit: 'hours', enumValue: UnitOfMeasure.HOURS },
  { id: 2, name: 'Quantities (LF/LM)', unit: 'linear_feet', enumValue: UnitOfMeasure.LINEAR_FEET },
];
